/*
 * © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

export const makeForm = (query: Record<string, string>, method: string, url: string) => {
  const form = document.createElement('form')
  form.id = 'fake-form'
  form.name = 'fake-form'
  document.body.appendChild(form)

  for (const key in query) {
    if (query[key] !== undefined && Object.hasOwnProperty.call(query, key)) {
      const input = document.createElement('input')
      input.type = 'text'
      input.name = key
      input.value = query[key]
      form.appendChild(input)
    }
  }

  form.method = method
  form.action = url
  form.submit()
  document.body.removeChild(form)
}

export const pickFields = (data: Record<string, unknown>, keys: string[]) => {
  const results = {}
  Object.keys(data).forEach(v => {
    if (keys.includes(v)) {
      results[v] = data[v]
    }
  })
  return results
}
